// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/level-off-lead.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/level-off-lead/level-off-lead.js';

mount([g0]);
